"use strict";

import "./User-Search.less";

import React from 'react';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';

import { delay } from '../../utils';

import { SearchActions } from '../../actions';
import { SearchStore } from '../../stores';

class Search extends React.Component {
  constructor() {
    super();

    this.state = {
      options: [],
      defaultSelected: [],
      isSelected: false
    };

    this._handleSelection = this._handleSelection.bind(this);
    this._handleTextChange = this._handleTextChange.bind(this);
    this._handleSearchStore = this._handleSearchStore.bind(this);
    this._handleRenderMenu = this._handleRenderMenu.bind(this);
  };

  static propTypes = {
    onChange: React.PropTypes.func,
    onSelection: React.PropTypes.func,
    value : React.PropTypes.arrayOf(React.PropTypes.object),
    // value: React.PropTypes.oneOfType([
    //   React.PropTypes.string,
    //   React.PropTypes.object
    // ])
  };

  componentWillMount() {
    // console.log("Will mound000000000000", this.props);
    const { value, placeholder="Search Users..." } = this.props;
    let stateObj = {};
    if(value) {
      stateObj['options'] = value;
      stateObj['defaultSelected'] = value;
    }
    this.placeholder = placeholder;
    this.setState(stateObj);    


    // if(value) {
    //   this.setState({ options: [value], defaultSelected: [value] });
    // }

    SearchStore.listen(this._handleSearchStore);
  };
  componentWillReceiveProps(newProps) {
    // console.log("componentWillReceiveProps", newProps.value);
    const { value } = newProps;
    let stateObj = {};
    if(value) {
      stateObj['options'] = value;
      stateObj['defaultSelected'] = value;
    }
    this.setState(stateObj)
  };
  componentWillUnmount() {
    SearchStore.unlisten(this._handleSearchStore);
  };

  render() {
    const { options, defaultSelected } = this.state;
    // console.log("options==========",options);

    return(
      <div ref={ elem => this.typeAhead = elem }>
        <Typeahead
          className="user-search"
          selected = {defaultSelected}
          // defaultSelected={ defaultSelected }
          options={ options }
          multiple={this.props.multiple || false}
          disabled = {this.props.disabled}
          labelKey={option => {return `${option.firstName || option._source.firstName} ${option.lastName || (option._source && option._source.lastName)}`}}
          onChange={ this._handleSelection }
          onInputChange={ this._handleTextChange }
          placeholder={this.placeholder}
          renderMenu={ this._handleRenderMenu }/>
      </div>
    );
  };

  _handleSearchStore(state) {
    if(state._users) {
      this.setState({ options: state._users });
    }
  };

  _handleSelection(values) {
    console.log("values=======",values);
    if(values && values.length) {
      if(this.props.multiple){
        this.props.onSelection(values);
      }else{
        this.props.onSelection(values[0]);
      }
      this.setState({ options: [], isSelected: true });
    }else{
      if(this.props.multiple){
        this.props.onSelection(values);
      }
      // console.log(' handle selection',values);
    }
  };

  _handleTextChange(value) {
    if(typeof this.props.onChange === 'function') this.props.onChange(value);

    delay(() => {
      if(!this.state.isSelected && value) {
        SearchActions.searchUsers({ keyword: value, fSearchFromCohort : this.props.fSearchFromCohort, cohortId : this.props.cohortId });
      }
      this.setState({ isSelected: false });
    }, 500);
  };

  _handleRenderMenu(results, menuProps) {
    return(
      <Menu { ...menuProps }>
        {
          results && results.map((result, idx) => {
            let firstName = result._source ? result._source.firstName : result.firstName;
            let lastName = result._source ? result._source.lastName : result.lastName;
            return(
              <MenuItem key={idx} option={ result } position={idx}>
                <figure key="logo">
                  <img src={ result._source && result._source.profilePicUrl || '/images/profile-icon.png' }/>
                </figure>
                <strong key="name">{`${firstName} ${lastName}` }</strong>
              </MenuItem>
            );
          })
        }
      </Menu>
    );
  };
}

export default Search;
